import { userSlice } from './slice';

export const { resetUser, setIsLoading } = userSlice.actions;
